var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"email-log-status-badge",class:_vm.badgeClass},[_c('i',{staticClass:"mr-2",class:_vm.iconClass}),_vm._v(" "+_vm._s(_vm.statusText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }